import { TYPES } from 'src/components/Elements/Picture';
import BREAKPOINTS from 'src/components/HTKit/Grid/constants';
import { THEMES } from 'src/components/HTKit/Forms/Button';
import desktopChatImage from 'src/images/products/consult-modal-img-desktop.png';
import mobileChatImage from 'src/images/products/consult-modal-img-mobile.png';
import desktopAfterHoursImage from 'src/images/products/chat-off-hours-desktop.png';
import mobileAfterHoursImage from 'src/images/products/chat-off-hours-mobile.png';

const PRODUCT_TYPE = Object.freeze({
  NO_INSTALLATION: 'noInstallation',
  WITH_INSTALLATION: 'withInstallation',
});

export default PRODUCT_TYPE;

export const MODAL_TEXTS = Object.freeze({
  businessHours: {
    header: 'Deciding is difficult, but we’re here to help',
    bodyText: 'Connect with one of our product specialists and have all your questions answered!',
  },
  afterHours: {
    header: 'Sorry we missed you',
    bodyText: 'Our product specialists are available to chat Monday through Friday 9am-5pm PST.',
    bodyTextSecondLine: 'If you’d like, you can pick a time for a specialist to give you a call.',
  },
});

const chatImageSources = [
  {
    srcSet: desktopChatImage,
    type: TYPES.PNG,
    media: `(min-width: ${BREAKPOINTS.LG_GRID}px)`,
  },
  {
    srcSet: mobileChatImage,
    type: TYPES.PNG,
  },
];

const afterHoursImageSources = [
  {
    srcSet: desktopAfterHoursImage,
    type: TYPES.PNG,
    media: `(min-width: ${BREAKPOINTS.LG_GRID}px)`,
  },
  {
    srcSet: mobileAfterHoursImage,
    type: TYPES.PNG,
  },
];

export const MODAL_CONTENTS = {
  imageSources: {
    showChatContent: chatImageSources,
    dontShowChatContent: afterHoursImageSources,
  },
  modalHeader: {
    showChatContent: MODAL_TEXTS.businessHours.header,
    dontShowChatContent: MODAL_TEXTS.afterHours.header,
  },
  modalBodyText: {
    showChatContent: MODAL_TEXTS.businessHours.bodyText,
    dontShowChatContent: MODAL_TEXTS.afterHours.bodyText,
  },
  modalBodyTextSecondLine: {
    dontShowChatContent: MODAL_TEXTS.afterHours.bodyTextSecondLine,
  },
  modalButtonTheme: {
    showChatContent: THEMES.V2SECONDARY,
    dontShowChatContent: THEMES.V2PRIMARY,
  },
};

export const calendlyLink = 'https://calendly.com/nicholas-157/product-questions';
